export default {
  formFields: {
    'fieldHelp': 'Clicca per aprire la descrizione',
    'defaultAbbreviation': 'df.: ',
    'paramJSONContent': 'Contenuto JSON',
    'wrongInputValue': 'Falso valore per questo parametro.',
    'notValidJsonString': 'Oggetto JSON non valido per :fieldName'
  }
}
